import { Controller } from "@hotwired/stimulus";

// Toggles the "Handwritten checks / mo" field based on the selected account type.
// Credit cards and lines of credit don't have handwritten checks, so the field
// is hidden (and its value cleared) when those types are selected.
export default class extends Controller {
  static targets = ["accountType", "checksField"];

  static values = {
    typesWithoutChecks: { type: Array, default: ["credit_card", "loan_loc"] },
  };

  connect() {
    this.toggleChecks();
  }

  toggleChecks() {
    const hide = this.typesWithoutChecksValue.includes(this.accountTypeTarget.value);
    this.checksFieldTarget.hidden = hide;

    if (hide) {
      const input = this.checksFieldTarget.querySelector("input");
      if (input) input.value = "";
    }
  }
}
